<template>
  <section class="bg-static-info-low py-24" :class="{ 'md:py-0': contained }">
    <div
      class="mx-auto max-w-full px-24"
      :class="contained ? 'md:px-0' : 'md:max-w-[900px] md:px-32'"
    >
      <h2 class="font-weight-heading-2 heading-2 relative">
        {{ i18n(translations.title) }}
      </h2>

      <p class="body-1 mt-8">
        {{ i18n(translations.description) }}
      </p>

      <RevButton
        class="mt-16 w-full"
        variant="primary"
        :to="loginTo"
        :tracking="{
          zone: 'help-center-suggest-login',
          name: 'login-cta',
        }"
      >
        {{ i18n(translations.loginButton) }}
      </RevButton>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { ROUTES } from '~/scopes/auth/route-names'

import translations from './SuggestLoginSection.translations'

defineProps<{ contained?: boolean }>()

const i18n = useI18n()
const resolveLocalizedRoute = useRouteLocationWithLocale()

const loginTo = resolveLocalizedRoute({
  name: ROUTES.AUTH.LOGIN,
})
</script>
